import { NotFound } from "./theme/NotFound";
import { useParams } from "react-router-dom";
import { WorkActivity } from "./TaskManager/WorkActivity/WorkActivity";
import { BoardColumns } from "./TaskManager/BoardColumns/BoardColumns";
import { WorkActivityStatuses } from "./TaskManager/WorkActivityStatuses/WorkActivityStatuses";
import { WorkActivityPriority } from "./TaskManager/WorkActivityPriority/WorkActivityPriority";
import { WorkActivityType } from "./TaskManager/WorkActivityType/WorkActivityType";
import { WorkActivityTaskType } from "./TaskManager/WorkActivityTaskType/WorkActivityTaskType";
import { Sprint } from "./TaskManager/Sprint/Sprint";
import { SprintBoardProvider } from "./TaskManager/ActivityTaskContext/SprintBoardProvider";
import { WorkActivityGroup } from "./TaskManager/WorkActivityGroup/WorkActivityGroup";
import { Calendar } from "./pages/DefaultHomePage/Dashed/components/CalendarDashed/Calendar";
import { _single } from "../core/services/dataBean/EntityCatalog";
import { BoardsManager } from "./TaskManager/BoardsManager/BoardsManager";


export const RouterManagerActivity = (props: any) => {
  const { view }: any = useParams();

  const renderSwitch = (url: string) => {
    switch (url) {
      //MARK: Calendario

      case "calendar":
        return <Calendar />;

      //MARK: Tareas por hacer
      case "tareas":
        return <WorkActivity />
      case "grupos-tareas":
        return <WorkActivityGroup />

      case "columnas-tablero":
        return <BoardColumns />

      case "estados-actividades":
        return <WorkActivityStatuses />

      case "prioridades-tareas":
        return <WorkActivityPriority />

      case "tipos-actividad":
        return <WorkActivityType />

      case "clasificacion-actividad":
        return <WorkActivityTaskType />

      case "periodos-trabajo":
        return <SprintBoardProvider><Sprint /></SprintBoardProvider>;

      case "tableros":
        return <BoardsManager />

      case "mis-tareas":
        return <BoardsManager IDAccount={_single.getAccountID()} />

      default:
        return <NotFound />;
    }
  };

  return (
    <div className="" >
      {renderSwitch(view)}
    </div>
  );
};
